<template>
    <div :class="['c-location-card', {'c-location-card--none':!locations.length}]">
        <template v-if="locations.length">
            <p class="section-title"><b>LOCATION ({{ locations.length > 1 ? `${this.selected+1} of ${locations.length}` : locations.length }})</b></p>
            
            <select v-if="locations.length > 1"
                v-model="selected" name="locations" 
                :id="providerName" 
                @change = "$emit('selectedLocation')"
                class="locations">

                <option v-for="(location, index) in locations" 
                    :key="location.name ? location.name+index : 'no-name'+index" 
                    :value="index" 
                    class="item__clinic">
                    
                    {{ location.entity }} {{ location.name ? location.name : 'No name' }} ({{ location.city }})
                </option>
            </select>
            <span v-else 
                v-for="(location, index) in locations.slice(0, 1)" 
                :key="location.name ? location.name+index : 'no-name'+index" 
                class="item__clinic"
            >
                {{ location.entity }} {{ location.name ? location.name : 'No name' }} ({{ location.city }})
            </span>
            
            <div v-for="(location, index) in locations" 
                :key="providerName+index" 
                :id="providerName + '-' + index"
                class="location-details"
                :class="[index == selected ? 'active' : '']">

                <div class="c-location-card-details">
                    <span v-if="location.distance" class="item__distance">
                        <svg width='18' height='21' viewBox='0 0 18 21' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9.06272 0.150391C13.8237 0.150391 17.6877 4.01439 17.6877 8.77539C17.6877 11.6849 16.1352 14.5369 13.5707 17.2394C12.6967 18.1709 11.7537 19.0104 10.8107 19.7579C10.4772 20.0224 10.1782 20.2524 9.90222 20.4479C9.72972 20.5744 9.61472 20.6549 9.54572 20.7009C9.25822 20.8964 8.87872 20.8964 8.59122 20.7009C8.52222 20.6549 8.39572 20.5744 8.23472 20.4479C7.95872 20.2524 7.64822 20.0224 7.32622 19.7579C6.38322 19.0104 5.45172 18.1594 4.56622 17.2394C2.00172 14.5369 0.449219 11.6849 0.449219 8.77539C0.449219 4.01439 4.31322 0.150391 9.07422 0.150391H9.06272ZM9.06272 1.87539C5.25622 1.87539 2.16272 4.96889 2.16272 8.77539C2.16272 11.1444 3.51972 13.6399 5.80822 16.0549C6.62472 16.9174 7.51022 17.7109 8.38422 18.4124C8.62572 18.6079 8.85572 18.7804 9.06272 18.9299C9.26972 18.7804 9.49972 18.6079 9.74122 18.4124C10.6267 17.7109 11.5007 16.9174 12.3172 16.0549C14.6057 13.6399 15.9627 11.1559 15.9627 8.77539C15.9627 4.96889 12.8692 1.87539 9.06272 1.87539ZM9.06272 5.32539C10.9717 5.32539 12.5127 6.86639 12.5127 8.77539C12.5127 10.6844 10.9717 12.2254 9.06272 12.2254C7.15372 12.2254 5.61272 10.6844 5.61272 8.77539C5.61272 6.86639 7.15372 5.32539 9.06272 5.32539ZM9.06272 7.05039C8.10822 7.05039 7.33772 7.82089 7.33772 8.77539C7.33772 9.72989 8.10822 10.5004 9.06272 10.5004C10.0172 10.5004 10.7877 9.72989 10.7877 8.77539C10.7877 7.82089 10.0172 7.05039 9.06272 7.05039Z' fill='#333333'/></svg>
                        <b>{{ trimmedMileage(location.distance) }} mi</b>
                    </span>
                    <span v-if="showingTravelTime"> | <span class="item__time"><b>{{ location.driveTime }}</b></span></span>
                    <p class="item__direction">{{ location.address }}</p>
                    <p class="item__get-direction"><a :href=location.googleMapsUrl target="_blank">Get Directions</a></p>
                    <p v-if="location.phoneNumber" class="item__phone">
                        <a :href="location.phoneNumberRaw">
                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.92328 2.34681C3.98078 3.25531 4.14179 4.14081 4.38329 4.99181L3.15279 6.2223C2.73879 4.9918 2.46279 3.69231 2.37078 2.34681H3.91179H3.92328ZM13.9973 14.6288C14.8713 14.8703 15.7568 15.0313 16.6538 15.0888V16.6068C15.3083 16.5148 14.0088 16.2503 12.7668 15.8363L13.9973 14.6173V14.6288ZM4.90078 0.299805H1.32429C0.760789 0.299805 0.300781 0.759804 0.300781 1.3233C0.300781 10.9258 8.07478 18.6998 17.6773 18.6998C18.2408 18.6998 18.7008 18.2398 18.7008 17.6763V14.1113C18.7008 13.5478 18.2408 13.0878 17.6773 13.0878C16.4123 13.0878 15.1703 12.8808 14.0318 12.5013C13.9283 12.4668 13.8248 12.4438 13.7098 12.4553C13.4453 12.4553 13.1923 12.5588 12.9853 12.7543L10.7313 15.0083C7.83328 13.5248 5.47579 11.1673 3.99229 8.2693L6.24629 6.0153C6.53379 5.7278 6.61429 5.3253 6.49929 4.9688C6.10829 3.7958 5.91279 2.5538 5.91279 1.3233C5.91279 0.759804 5.45279 0.299805 4.88929 0.299805H4.90078Z" fill="#333333"/></svg>
                            {{ location.phoneNumber }}
                        </a>
                    </p>
                </div>
            </div>

        </template>
        <template v-else>
            <div class="locations-no-result"><p><b>No Locations Found</b></p></div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: "LocationCard",
        data: () => {
            return {
                selected: 0,
                locationDetailContainersArr: null,
                showingTravelTime: false,
                origin: '',
            };
        },
        props: {
            locations: Array,
            providerName: String
        },
        computed: {
            ...mapGetters(["showTravelTime", "Location", "ActiveFilters", "resultsLoading"])
        },
        methods: {
            trimmedMileage(miles) {
                if (!isNaN(miles)) {
                    return parseFloat(miles).toFixed(1);
                }
                return 'Invalid Input';
            },
            addDriveTimesData() {
                this.locations.forEach(location => {
                    location['driveTime'] = null;
                });
            },
            async retrieveDriveTimes(location) {
                const directionsService = new google.maps.DirectionsService();
                const request = {
                    origin: this.ActiveFilters.LocationName,
                    destination: location.address,
                    travelMode: 'DRIVING',
                };

                directionsService.route(request, (response, status) => {
                    if (status === 'OK') {
                        const route = response.routes[0];
                        const leg = route.legs[0];
                        const duration = leg.duration.text;
                        this.$set(location, 'driveTime', duration);
                    } else {
                        console.error('Error fetching drive time:', status);
                    }
                });
            },
            async calculateDriveTimes() {
                for (let i = 0; i < this.locations.length; i++) {
                    await this.retrieveDriveTimes(this.locations[i]);
                }
            },
        },
        mounted() {
            //this.addDriveTimesData()
        },
        watch: {
            'showTravelTime': {
                immediate: true,
                handler(showTravelTime) {
                    if (showTravelTime === true) {
                        this.showingTravelTime = true;
                        this.calculateDriveTimes();
                    } else {
                        this.showingTravelTime = false;
                    }
                }
            },
            'resultsLoading': function(){
                if (this.showTravelTime === true && !this.resultsLoading) {
                    this.calculateDriveTimes();
                }
            }
        }
    };
</script>  